import { render, staticRenderFns } from "./MaterialCategory.vue?vue&type=template&id=2ce32bf8&"
import script from "./MaterialCategory.vue?vue&type=script&lang=js&"
export * from "./MaterialCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports